import React from 'react';
import { Flex } from '@withjoy/joykit';
import SortableList from '@shared/components/SortableList';
import { FaqItem } from './FaqItem';
import { FaqItemWithId } from '../Faq.types';

type FaqListProps = {
  items: FaqItemWithId[];
  onEdit: (item: FaqItemWithId) => void;
  onDelete: (item: FaqItemWithId) => void;
  onReorder: (reorderedItems: FaqItemWithId[]) => void;
};

export const FaqList = (props: FaqListProps) => {
  const { items, onEdit, onDelete, onReorder } = props;

  return (
    <Flex
      flexDirection="column"
      gap={4}
      paddingBottom="6.5rem"
    >
      <SortableList
        items={items}
        onChange={onReorder}
        hasDragHandle={true}
        renderItem={item => (
          <FaqItem
            item={item}
            onEdit={() => onEdit(item)}
            onDelete={() => onDelete(item)}
          />
        )}
      />
    </Flex>
  );
};
